"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("./selector.scss");
const displayWrapper_1 = require("./common/displayWrapper");
const legacyFirestore_1 = require("./hooks/legacyFirestore");
const multipleSelector_1 = __importDefault(require("./multipleSelector"));
const hooks_1 = require("common/hooks");
const MultipleExternalKeySchemaComponent = (props) => {
    const { schema: originalSchema } = props;
    const { list: options } = (0, legacyFirestore_1.useQueryResource)(originalSchema);
    const schema = (0, react_1.useMemo)(() => {
        return Object.assign(Object.assign({}, originalSchema), { schemaType: "multipleSelector", options: options || [] });
    }, [options, originalSchema]);
    return (react_1.default.createElement(multipleSelector_1.default, Object.assign({}, props, { schema: schema })));
};
MultipleExternalKeySchemaComponent.display = (0, displayWrapper_1.DisplayComponent)("MultipleExternalKeyDisplayComponent", (value, schema) => {
    const s = (0, hooks_1.useStringIntl)();
    const { list: options } = (0, legacyFirestore_1.useQueryResource)(schema);
    const valueSet = (0, react_1.useMemo)(() => {
        try {
            return new Set(Array.isArray(value) ? value : [value]);
        }
        catch (e) {
            return new Set();
        }
    }, [value]);
    const optionMap = options && (0, legacyFirestore_1.toMap)(options);
    if (schema.href) {
        return value ? (react_1.default.createElement("a", { href: schema.href(value) }, s(optionMap === null || optionMap === void 0 ? void 0 : optionMap.get(value)))) : (s(optionMap === null || optionMap === void 0 ? void 0 : optionMap.get(value)) || "");
    }
    else {
        return (react_1.default.createElement("div", { style: { lineHeight: "1.8em" } }, options === null || options === void 0 ? void 0 : options.filter((option) => valueSet.has(option.value)).map((option, index, array) => {
            return (react_1.default.createElement("span", { key: index, style: {
                    background: "#ddd",
                    borderRadius: "7px",
                    padding: "4px 10px",
                    margin: "3px",
                    fontSize: "0.8em",
                    whiteSpace: "nowrap",
                } }, option.title));
        })));
    }
});
exports.default = MultipleExternalKeySchemaComponent;
